export default __webpack_public_path__ + "a2d64115eebe9881e33630f707a35043.png";